module.exports = new __parcel__URL__("native-issue-table-skeleton.tpl.f74ea9a0.svg").toString();